import { useContext } from "react";
import {} from "bodycodi/cmap/app/js/common";

import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";
import logo from "bodycodi/cmap/app/img/bodycodi-logo-blue.png";

type FindEmailCompletePop = {
  d: any;
};

const FindEmailCompletePopWrap = ({ d }: FindEmailCompletePop) => {
  const { state: state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "FIND_EMAIL_COMPLETE_POP",
      open: { findEmailCompletePop: false },
    });
  };

  return (
    <>
      <CustomDialog open={state.findEmailCompletePop} onClose={handleClose}>
        {state.findEmailCompletePop && (
          <>
            <FindEmailCompletePop d={d} />
          </>
        )}
      </CustomDialog>
    </>
  );
};

const FindEmailCompletePop = ({ d }: FindEmailCompletePop) => {
  const { dispatch } = useContext(DispatchContext);

  const clickGoLogin = () => {
    dispatch({ type: "CLOSE_ALL_POP" });
  };

  return (
    <div className="find-password-complete-pop">
      <div style={{ width: "100%" }}>
        <img className="icon" src={logo} />
        <div className="preRegular black1" style={{ textAlign: "center", marginBottom: 12 }}>
          {d.name}님의 이메일 아이디
        </div>
        <div className="bold black" style={{ textAlign: "center" }}>
          {d.email}
        </div>
      </div>

      <div className="btn" onClick={clickGoLogin}>
        로그인페이지 가기
      </div>
    </div>
  );
};

export default FindEmailCompletePopWrap;
